import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import ProductCard from '../../components/ProductCard';
import '../Profile.css';

const Favorites = () => {
  const { user, removeFavorite, loadLikes } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const items = user?.likes || [];

  useEffect(() => {
    if (!user) { navigate('/', { replace: true }); return; }
    if (user?.id) {
      setLoading(true);
      loadLikes().finally(() => setLoading(false));
    }
  }, [ user?.id,navigate]);

  if (!user) return null;

  if (loading) {
    return (
      <div className="favorites-loading">
        טוען מוצרים אהובים...
      </div>
    );
  }

  const handleRemove = async (itemId) => {
    await removeFavorite(itemId);
  };

  return (
    <div className="favorites-container">
      {items.length === 0 && <div className="favorites-empty">אין מועדפים עדיין.</div>}

      <div className="favorites-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '38px',
        padding: '20px 40px'
      }}>
        {items.map(it => (
          <ProductCard key={it.id} item={it} onToggleFavorite={() => handleRemove(it.id)} isFavorite={true} />
        ))}
      </div>
    </div>
  );
};

export default Favorites;
